import type { TypographyVariantMapping } from './typography.types';

export const typographyVariantMapping: TypographyVariantMapping = {
  default: 'p',
  'heading-1': 'h1',
  'heading-2': 'h2',
  'heading-3': 'h3',
  'heading-4': 'h4',
  'heading-5': 'h5',
  'heading-xl': 'h1',
  link: 'a',
  'link-small': 'a',
  text: 'p',
  'text-bold': 'p',
  'text-mono': 'code',
  'text-mono-small': 'code',
  'text-small': 'p',
  'text-small-bold': 'p',
};
